export const FETCH_REFERENCE_ENTRIES = "FETCH_REFERENCE_ENTRIES";
export const FETCH_REFERENCE_ENTRIES_SUCCESS =
  "FETCH_REFERENCE_ENTRIES_SUCCESS";
export const FETCH_REFERENCE_ENTRIES_FAILED = "FETCH_REFERENCE_ENTRIES_FAILED";

export const CREATE_REFERENCE_ENTRY = "CREATE_REFERENCE_ENTRY";
export const CREATE_REFERENCE_ENTRY_SUCCESS = "CREATE_REFERENCE_ENTRY_SUCCESS";
export const CREATE_REFERENCE_ENTRY_FAILED = "CREATE_REFERENCE_ENTRY_FAILED";

export const DELETE_REFERENCE_ENTRY = "DELETE_REFERENCE_ENTRY";
export const DELETE_REFERENCE_ENTRY_SUCCESS = "DELETE_REFERENCE_ENTRY_SUCCESS";
export const DELETE_REFERENCE_ENTRY_FAILED = "DELETE_REFERENCE_ENTRY_FAILED";

export const UPDATE_REFERENCE_ENTRY = "UPDATE_REFERENCE_ENTRY";
export const UPDATE_REFERENCE_ENTRY_SUCCESS = "UPDATE_REFERENCE_ENTRY_SUCCESS";
export const UPDATE_REFERENCE_ENTRY_FAILED = "UPDATE_REFERENCE_ENTRY_FAILED";

export const SET_ERROR_MESSAGE = "SET_ERROR_MESSAGE";
